<template>
  <div class="search-bar-wrapper">
    <form
      action=""
      method="post"
      @submit.prevent=""
    >
      <div class="search-bar-holder">
        <div class="search-bar">
          <input
            v-model="keyword"
            type="text"
            name="search"
            autocomplete="off"
            :placeholder="placeholder"
          >
          <SearchBarIcon class="search-icon" />
          <CloseIcon v-if="keyword" class="close-btn" @click="clearInput" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { delayOnKeyup } from '../utils/helper';
import SearchBarIcon from '../assets/svg/icon-search.svg?vue-component';
import CloseIcon from '../assets/svg/close-icon.svg?vue-component';

export default {
  components: {
    SearchBarIcon,
    CloseIcon,
  },
  props: {
    placeholder: { type: String, required: true },
    value: { type: String, default: '', required: false },
  },
  data() {
    return {
      keyword: this.value,
    };
  },
  watch: {
    keyword() {
      if (this.keyword === '') {
        this.$emit('search', this.keyword);
      } else {
        delayOnKeyup(async () => {
          this.$emit('search', this.keyword);
        });
      }
    },
    value(v) {
      this.keyword = v;
    },
  },
  methods: {
    clearInput() {
      this.keyword = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar-wrapper {
  width: 100%;

  form {
    .search-bar {
      position: relative;

      input {
        height: 40px;
        border: 1px solid #F0F0F2;
        border-radius: var(--spacing-100);
        padding: 12px 54px;
      }

      .search-icon {
        position: absolute;
        left: 21px;
        top: 10px;

        path[stroke] {
          stroke: var(--main-light-shade-4);
        }
      }

      .close-btn {
        position: absolute;
        right: 16px;
        top: 13px;
        cursor: pointer;

        path[fill] {
          fill: var(--main-light-shade-3);
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .search-bar-wrapper form .search-bar input {
    border: 1px solid var(--main-light-shade-2-200);
  }
}
</style>
